<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="advertiser-edit-popup">
        <ValidationObserver ref="form" class="centerx default-input" v-slot="{handleSubmit}">
            <div class="centerx default-input">
                <vs-row>
                    <vs-col vs-w="6">
                        <ValidationProvider vid="name" :name="$t('modals.Advertiser_name')" rules="required|minmax:3,50" v-slot="{ errors }">
                            <div class="p-2">
                                <label class="text-sm opacity-75">{{$t('modals.Advertiser_name')}}</label>
                                <vs-input
                                    class="inputx w-full"
                                    :placeholder="$t('modals.Advertiser_name')"
                                    v-model="popupFields.name"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </vs-col>
                    <vs-col vs-w="6">
                        <ValidationProvider vid="safe_name" :name="$t('modals.Safe_name')" rules="required|minmax:3,50" v-slot="{ errors }">
                            <div class="p-2">
                                <label class="text-sm opacity-75">{{$t('modals.Safe_name')}}</label>
                                <vs-input
                                    class="inputx w-full"
                                    :placeholder="$t('modals.Safe_name')"
                                    v-model="popupFields.safe_name"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </vs-col>
                </vs-row>

                <vs-row v-if="popupType !== 'cloneAdvertiser'">
                    <vs-col vs-w="6">
                        <div class="p-2 flex">
                            <div>{{ $t('modals.Falcon_integration') }}</div>
                            <vs-switch class="ml-2" color="success" v-model="popupFields.is_falcon" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2 flex">
                            <div>{{ $t('table.Is_internal') }}</div>
                            <vs-switch class="ml-2" color="success" v-model="popupFields.is_internal" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2 flex">
                            <div>{{ $t('modals.Falcon_statistic') }}</div>
                            <vs-switch class="ml-2" color="success" v-model="popupFields.statistic_falcon" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2 flex">
                            <div>{{ $t('table.autologin') }}</div>
                            <vs-switch class="ml-2" color="success" v-model="popupFields.is_redirect" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6" v-can="'settings_moderation.advertiser_moderation_toggle'">
                        <div class="p-2 flex">
                            <div>Manual FTD</div>
                            <vs-switch class="ml-2" color="success" v-model="popupFields.is_manual_deposit_moderation" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                        </div>
                    </vs-col>

                    <vs-col vs-w="12" v-if="isMounted && !popupFields.is_falcon">
                        <div class="p-2">
                            <ValidationProvider vid="type" :name="$t('global.Type')" rules="required" v-slot="{ errors }">
                                <v-select
                                    class="w-full"
                                    :placeholder="$t('global.Type')"
                                    :clearable="false"
                                    :options="types"
                                    :reduce="type => type.id"
                                    appendToBody
                                    label="name"
                                    v-model="selectedIntegrationType"
                                    :calculate-position="withPopper"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                </vs-row>
            </div>

            <!-- Save & Reset Button -->
            <vs-row>
                <vs-col vs-w="12">
                    <div class="p-2">
                        <div class="flex flex-wrap items-center justify-end" :class="{'mt-8': popupType !== 'cloneAdvertiser'}">
                            <vs-button :disabled="loading" @click.prevent="handleSubmit(popupType !== 'cloneAdvertiser' ? submitForm : cloneAdv)">
                                {{ $t('buttons.Save') }}
                            </vs-button>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
        </ValidationObserver>
    </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import vSelect from 'vue-select'

import EventBus from '@/store/eventBus'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import {vSelectPosition, checkPermission} from "@/utils/mixins"


export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },
    props: ['popupData', 'popupType', 'popupButton'],
    mixins: [vSelectPosition, checkPermission],
    data() {
        return {
            loading: false,
            popupFields: {
                name: '',
                safe_name: '',
                is_falcon: false,
                is_internal: false,
                is_redirect: true,
                statistic_falcon: false,
                advertiser_category: 1,
                is_manual_deposit_moderation: false
            },
            submitButtonText: '',
            types: [],
            selectedIntegrationType: null,
            currentAdv: null,
            isMounted: false,
            categoryOptions: []
        }
    },

    methods: {
        async cloneAdv() {
            try {
                this.loading = true
                const obj = {
                    id: this.popupData.id,
                    name: this.popupFields.name,
                    safe_name: this.popupFields.safe_name
                }

                await send(this.$url.advrtsr.advclone, 'POST', {data: obj})

                EventBus.$emit('getAdv')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (e) {
                if (e.response) {
                    const response = e.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }

                new ErrorHandler(e).send
            } finally {
                this.loading = false
            }
        },

        async submitForm() {
            try {
                this.loading = true
                const data = {
                    name: this.popupFields.name.trim(),
                    safe_name: this.popupFields.safe_name.trim(),
                    is_falcon: this.popupFields.is_falcon ? 1 : 0,
                    is_internal: this.popupFields.is_internal ? 1 : 0,
                    is_redirect: this.popupFields.is_redirect ? 1 : 0,
                    statistic_falcon: this.popupFields.statistic_falcon ? 1 : 0,
                    is_manual_deposit_moderation: this.popupFields.is_manual_deposit_moderation ? 1 : 0,
                    advertiser_category_id: this.popupFields.advertiser_category
                }

                if (!data.advertiser_categories || !this.isPermission('settings_advertiser.change_categories')) delete data.advertiser_categories

                if(this.popupFields.is_falcon) {
                    delete data.integration_type_id
                } else {
                    if(this.popupType !== 'createAdvertiser' && (this.popupFields.integration_type_id !== this.selectedIntegrationType)) {
                        data.type_change = 1
                    }

                    data.integration_type_id = this.selectedIntegrationType
                }

                if(this.popupType === 'createAdvertiser') {
                    await send(this.$url.advrtsr.create, 'POST', {
                        data,
                        ids: this.popupData
                    })
                }

                if(this.popupType === 'editAdvertiser') {
                    data.id = this.popupData.data.id
                    await send(this.$url.advrtsr.update, 'PUT', {
                        data,
                        ids: this.popupData
                    })
                }

                EventBus.$emit('getAdv')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch(error) {
                if (error.response) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(error).send
            } finally {
                this.loading = false
            }
        }
    },

    async mounted() {
        // this.types = await send(this.$url.advrtsr_integration.getIntegrationType, 'GET').then(response => response.data.result)
        try {
            this.types = this.popupData.types
            this.submitButtonText = this.popupButton

            this.$nextTick(() => {
                if(this.popupType === 'editAdvertiser') {
                    const {data} = this.popupData

                    this.popupFields.id = data.id
                    this.popupFields.name = data.name.trim()
                    this.popupFields.safe_name = data.safe_name.trim()
                    this.popupFields.is_falcon = data.is_falcon
                    this.popupFields.is_internal = data.is_internal
                    this.popupFields.is_redirect = data.is_redirect
                    this.popupFields.statistic_falcon = data.statistic_falcon
                    this.popupFields.is_manual_deposit_moderation = data.is_manual_deposit_moderation
                    this.popupFields.advertiser_category = 1
                    this.selectedIntegrationType = data.integration_type_id
                }
            })

            this.isMounted = true

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>
<style lang="scss">
#user-edit-popup {
    .vs-tabs--li button {
        font-size: 0.8rem;
        line-height: 1;
    }

    .vs-tabs-position-left .vs-tabs--li {
        padding: 0;
    }

    .vx-card .vx-card__collapsible-content .vx-card__body {
        padding: 1rem;
    }

    .vx-card .vx-card__collapsible-content.vs-con-loading__container {
        height: 300px;
    }

    .vs-tabs-position-left .con-ul-tabs {
        width: 180px;
        height: 230px;
        overflow-y: scroll;
    }
}
</style>
